import { IQuote, IQuoteRo } from "interfaces";
import { useCallback } from "react";
import {
  selectForm,
  setEmail as _setEmail,
  setQuote,
  setQuoteRes as _setQuoteRes,
  setTransferData as _setTransferData,
  setTransferId as _setTransferId,
} from "store/slices";
import useDispatch from "./useDispatch";
import useSelector from "./useSelector";

export function useForm() {
  const dispatch = useDispatch();
  const { quoteIn, quoteOut, quoteRes, email, transferId, transferData } = useSelector(selectForm);

  const isActiveQuote = useCallback(() => {
    if (!quoteRes?.quote?.quoteExpirationTime) {
      return false;
    }
    if (new Date() < new Date(quoteRes?.quote?.quoteExpirationTime)) {
      return true;
    }
    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteRes, quoteRes?.quote?.quoteExpirationTime]);

  const setBuyQuote = useCallback(
    (dto: Partial<IQuote>) => {
      dispatch(setQuote({ type: "in", ...quoteIn, ...dto }));
    },
    [dispatch, quoteIn]
  );

  const setSellQuote = useCallback(
    (dto: Partial<IQuote>) => {
      dispatch(setQuote({ type: "out", ...quoteOut, ...dto }));
    },
    [dispatch, quoteOut]
  );

  const setEmail = useCallback(
    (value: string) => {
      dispatch(_setEmail(value));
    },
    [dispatch]
  );
  const setTransferId = useCallback(
    (id: string) => {
      dispatch(_setTransferId(id));
    },
    [dispatch]
  );
  const setTransferData = useCallback(
    (data: Record<string, any>) => {
      dispatch(_setTransferData(data));
    },
    [dispatch]
  );

  const setQuoteRes = useCallback(
    (ro: IQuoteRo) => {
      dispatch(_setQuoteRes(ro));
    },
    [dispatch]
  );

  return {
    transferId,
    transferData,
    quoteRes,
    isActiveQuote,
    email,
    quoteIn,
    quoteOut,
    setBuyQuote,
    setSellQuote,
    setEmail,
    setQuoteRes,
    setTransferId,
    setTransferData,
  };
}
